import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';

export const LOCALSTORAGE_PREMIUM_TRIAL_ON_SIGNUP_KEY = 'premiumTrialOnSignup';
export const LOCALSTORAGE_PREMIUM_TRIAL_COHORT = 'reverseTrialCohort';

const localStorage = createLocalStorageProvider('jsw-onboarding-premium-reverse-trial');

export const localStorageGetOnboardingPremiumTrial = (): boolean | undefined => {
	try {
		const value = localStorage.get(LOCALSTORAGE_PREMIUM_TRIAL_ON_SIGNUP_KEY);

		// localStorage.get is able to return proper booleans and not stringified booleans like "true"/"false"
		return value;

		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			error,
			meta: {
				id: 'localStorageGetOnboardingPremiumTrial',
				packageName: 'jiraReverseTrialUtils',
			},
			sendToPrivacyUnsafeSplunk: true,
		});
		// note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
		return undefined;
	}
};

export const localStorageGetOnboardingPremiumTrialCohort = (): string | undefined => {
	try {
		const value = localStorage.get(LOCALSTORAGE_PREMIUM_TRIAL_COHORT);
		return value;

		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			error,
			meta: {
				id: 'localStorageGetOnboardingPremiumTrial',
				packageName: 'jiraReverseTrialUtils',
			},
			sendToPrivacyUnsafeSplunk: true,
		});
		// note: unlike window.localStorage, the get method returns undefined instead of null. Thus this also returns undefined.
		return undefined;
	}
};

export const localStorageSetOnboardingPremiumTrial = (premiumTrialOnSignup: boolean): void => {
	try {
		localStorage.set(LOCALSTORAGE_PREMIUM_TRIAL_ON_SIGNUP_KEY, premiumTrialOnSignup);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			error,
			meta: {
				id: 'localStorageSetOnboardingPremiumTrial',
				packageName: 'jiraReverseTrialUtils',
			},
			sendToPrivacyUnsafeSplunk: true,
		});
	}
};

export const localStorageSetOnboardingPremiumTrialCohort = (reverseTrialCohort: string): void => {
	try {
		localStorage.set(LOCALSTORAGE_PREMIUM_TRIAL_COHORT, reverseTrialCohort);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			error,
			meta: {
				id: 'localStorageSetOnboardingPremiumTrial',
				packageName: 'jiraReverseTrialUtils',
			},
			sendToPrivacyUnsafeSplunk: true,
		});
	}
};
